import { useState, useEffect, useCallback } from 'react';
import { useRenovationStore } from '../store/useRenovationStore';
import dayjs from 'dayjs';
import { HiOutlineTrendingUp, HiOutlineUsers, HiOutlineExclamation } from "react-icons/hi";

export const useRenovations = (type = '10-days') => {
  const { 
    filteredItems, 
    loading, 
    totalAccounts, 
    revenueAtRisk, 
    criticalAccounts,
    getRenovations, 
    searchRenovations, 
    clearSearch 
  } = useRenovationStore();

  const [searchText, setSearchText ] = useState('');
  const today = dayjs().format('YYYY-MM-DD');
  const tenDays = dayjs().add(10, 'day').format('YYYY-MM-DD');

  useEffect(() => {
    getRenovations(type);
  }, [type, getRenovations]);

  const handleSearch = useCallback((val) => {
    setSearchText(val);
    searchRenovations(val);
  }, [searchRenovations]);

  const handleClear = useCallback(() => {
    setSearchText("");
    clearSearch();
  }, [clearSearch]);

  const stats = [
    { 
      title: "Monto en Riesgo", 
      value: revenueAtRisk, 
      icon: <HiOutlineTrendingUp size={24} />, 
      color: "red", 
      currency: true,
      description: "Suma de abonos por vencer"
    },
    { 
      title: "Cuentas por Vencer", 
      value: totalAccounts, 
      icon: <HiOutlineUsers size={24} />, 
      color: "yellow", 
      mono: false,
      description: "Total de renovaciones pendientes"
    },
    { 
      title: "Críticos", 
      value: criticalAccounts, 
      icon: <HiOutlineExclamation size={24} />, 
      color: "orange", 
      mono: false,
      description: "Vencen hoy o ya expiraron"
    }
  ];

  return {
    items: filteredItems,
    loading,
    searchText,
    today,
    tenDays,
    stats,
    handleSearch,
    handleClear,
    refresh: () => getRenovations(type)
  };
};
